module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_FR-4e71341bcbff4de0545b8b8f7a9352c9.svg";